import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EventqActionLoader } from '@ecam/eventq-components';

@Component({
  selector: 'app-escalation-waiting',
  imports: [EventqActionLoader],
  templateUrl: './escalation-waiting.html',
  styleUrl: './escalation-waiting.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EscalationWaitingPage {
  readonly message = 'Please select an event in Resolve';
}
